module.exports = __webpack_public_path__ + "static/img/consumePlatform.ddddd5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consumePlatform.png
// module id = R9Z0
// module chunks = 1